export function Document432Icon() {
  return (
    <svg
      width="432"
      height="527"
      viewBox="0 0 432 527"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M428 163.659V491C428 508.673 413.673 523 396 523H36C18.3269 523 4 508.673 4 491V36C4 18.3269 18.3269 4 36 4H258.942M428 163.659L258.942 4M428 163.659H290.942C273.269 163.659 258.942 149.332 258.942 131.659L258.942 4"
        stroke="currentColor"
        strokeWidth="8"
      />
    </svg>
  );
}
